
import {
  defineComponent, ref, VNode, isVNode,
} from 'vue';

const isTabPane = (vNode: VNode) => vNode.props?.tab !== undefined;

export default defineComponent({
  props: {
    /** (v-model) 激活的页面 key */
    modelValue: { type: String, required: true },
  },
  emits: ['update:modelValue'],
  setup(props, ctx) {
    const tabPanesInit: {
        tab: string;
        name: string;
      }[] = [];

    /** 一级子节点 */
    const children = (ctx.slots.default?.() || []);
    children.forEach((child) => {
      if (isTabPane(child)) {
        // 如果是 TabPane，加到列表中
        tabPanesInit.push({
          tab: child.props?.tab || '',
          name: child.props?.name || '',
        });
      } else if (child.children?.length && Array.isArray(child.children)) {
        // 如果有子节点，对二级节点判断是否是 TabPane，如果是则加入到列表中
        child.children.forEach((c) => {
          if (isVNode(c) && isTabPane(c)) {
            tabPanesInit.push({
              tab: c.props?.tab || '',
              name: c.props?.name || '',
            });
          }
        });
      }
    });
    const tabPanes = ref(tabPanesInit);

    /** scroll-content 元素 */
    const scrollContentRef = ref<HTMLDivElement>();

    /** 变更标签页 */
    const changeTabPage = (pageKey: string) => {
      if (props.modelValue === pageKey) {
        return;
      }
      ctx.emit('update:modelValue', pageKey);
    };

    /** 点击 tab 项 */
    const handleClickTab = (pageKey: string) => {
      const pageIndex = tabPanes.value.findIndex((v) => v.tab === pageKey);
      if (!scrollContentRef.value || pageIndex === -1) {
        return;
      }
      const { offsetWidth } = scrollContentRef.value;
      scrollContentRef.value.scrollTo(pageIndex * offsetWidth, 0);
    };

    /** 内容横向滚动监听 */
    const handleContentScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const { scrollLeft, offsetWidth } = target;
      const scrollRatio = Math.round(scrollLeft / offsetWidth);
      if (tabPanes.value[scrollRatio].tab !== props.modelValue) {
        // 若滚动比例为整数（贴在某页左边沿）且当前滚动位置不等于 modelValue，将 modelValue 更新为当前滚动位置所在页
        changeTabPage(tabPanes.value[scrollRatio].tab);
      }
    };

    return {
      tabPanes,
      scrollContent: scrollContentRef,
      handleClickTab,
      handleContentScroll,
    };
  },
});
